module.exports = __webpack_public_path__ + "static/img/1.26d9f6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/7/zh/1.png
// module id = 7Izr
// module chunks = 0